import { render, staticRenderFns } from "./StackRouterHeaderBar.vue?vue&type=template&id=59695980&scoped=true"
import script from "./StackRouterHeaderBar.vue?vue&type=script&lang=js"
export * from "./StackRouterHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./StackRouterHeaderBar.vue?vue&type=style&index=0&id=59695980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59695980",
  null
  
)

export default component.exports